import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";
import { RecruiterScreeningCallMeNowConfirmationActions } from "./RecruiterScreeningCallMeNowConfirmationActions";
import { RecruiterScreeningCallMeNowContactActions } from "./RecruiterScreeningCallMeNowContactActions";

export function RecruiterScreeningCallMeNowActions() {
  const { stage } = useRecruiterBookingFlowContext();

  switch (stage) {
    case "contact-details": {
      return <RecruiterScreeningCallMeNowContactActions />;
    }

    case "confirmation": {
      return <RecruiterScreeningCallMeNowConfirmationActions />;
    }

    default: {
      return null;
    }
  }
}
